import CarouselComponent from "@/components/CarouselComponent";
import DragSelect from "@/pages/matrix/DragSelect";
import { get, isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import BaseRadio from "../BaseRadio";
import "./index.less";

// 行单选
export default function MatrixRadio(props) {
  console.log(`src\\pages\\radio\\MatrixRadio\\index.jsx`);
  const { info, answer, changeAnswer } = props;
  let {
    id,
    childs,
    preferences: { childPrefer = {} },
  } = info;
  const [selectedCodes, setSelectedCodes] = useState({});
  const [carouseFn, setcarouseFn] = useState(null);

  const { optionForm } = childPrefer;

  // 行列均单选
  function unsetValue(code) {
    function id2Code(id) {
      let code;
      childs.map((c) =>
        c.options.map((o) => {
          if (o.id === id) {
            code = o.codeValue;
          }
        })
      );
      return code;
    }
    for (const [qId, obj] of Object.entries(answer[info.id] || {})) {
      for (const [oId, _] of Object.entries(obj)) {
        const codeValue = id2Code(oId);
        if (code === codeValue) {
          delete answer[info.id][qId];
          changeAnswer(answer);
        }
      }
    }
  }

  useEffect(() => {
    if (isEmpty(selectedCodes)) {
      try {
        const answerObj = answer[info.id];
        const codes = {};
        childs.map((question, index) => {
          for (const [qId, obj] of Object.entries(answerObj)) {
            if (qId === question.id) {
              question.options.map((option) => {
                if (Object.keys(obj)?.[0] === option.id) {
                  codes[index] = option.codeValue;
                }
              });
            }
          }
        });
        setSelectedCodes(codes);
      } catch (error) {}
    }
  }, [answer]);

  const onChangeAnswer = (subId, newAnswer) => {
    changeAnswer({
      ...get(answer, `[${id}]`, {}),
      [subId]: newAnswer,
    });
  };

  // 删除子问题的答案
  const deleteAnswer = (subId) => {
    delete answer[id][subId];
  };

  let children = (childs || []).map((child, index) => {
    if (+child.moduleOption > 0) {
      if (+child.moduleOption === 2) {
        return null;
      } else {
        return (
          <div className="q-item q-item-module" key={child.id}>
            <div
              className="q-item-title q-item-title-module"
              dangerouslySetInnerHTML={{
                __html: child.description
                  .replace(/<p><\/p>/g, "<br />")
                  .replace(/\n\n/g, "<br />")
                  .replace(/\s{2}/g, "&nbsp;&nbsp;"),
              }}
            />
          </div>
        );
      }
    }
    console.log("father component: ", selectedCodes);
    const cid = child.id;
    const answers = answer[info.id] || answer;
    const answerProp = answers?.[cid] ? { [cid]: answers[cid] } : {};
    return (
      <div className="q-item" key={child.id}>
        <div
          className="q-item-title"
          dangerouslySetInnerHTML={{
            __html: child.description
              .replace(/<p><\/p>/g, "<br />")
              .replace(/\n\n/g, "<br />")
              .replace(/\s{2}/g, "&nbsp;&nbsp;"),
          }}
        />

        <div className="q-item-content" id={child.id}>
          <BaseRadio
            info={{
              ...child,
              childPrefer,
              ...info,
              options: child.options,
              id: child.id,
            }}
            // 这里的answer是每个问题的answer
            answer={answerProp}
            unsetValue={unsetValue}
            changeAnswer={(newAnswer) => {
              try {
                let _newAnswerId = Object.keys(newAnswer)[0];
                let openIdList = child.options
                  .filter((item) => item.open !== 0)
                  .map((item) => item.id);
                if (!openIdList.includes(_newAnswerId)) {
                  setTimeout(() => {
                    carouseFn && carouseFn.autoplayFn();
                  }, 500);
                }
                onChangeAnswer(child.id, newAnswer);
              } catch (error) {
                console.error(error);
              }
            }}
            deleteAnswer={deleteAnswer}
            selectedCodes={selectedCodes}
            setSelectedCodes={setSelectedCodes}
            position={index}
          />
        </div>
      </div>
    );
  });

  if (optionForm === 3) {
    children = <DragSelect {...props} />;
  }
   return (
    <div className="matrix-radio" style={{  font: "-webkit-mini-control"    }}>
      <div className="q-matrix-content">
        <CarouselComponent
          colData={childs}
          info={info}
          callback={(dom, autoplayFn, current) => {
            setcarouseFn({ ...dom, autoplayFn, current });
          }}
        >
          {children}
        </CarouselComponent>
      </div>
    </div>
  );
}
